import { Component } from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import classBind from 'classnames/bind';

import styles from './styles.scss';

let cx = classBind.bind(styles);

class Loader extends Component {
  render() {
    var style = this.props.style;
    var size = this.props.size || 'medium';

    let className = cx({
      loader: true,
      [`${style}`]: true,
      [`${size}`]: true,
    });

    return (
      <div className="container">
        <div className={classnames(className)} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    style: state.configuration.style,
  };
};

export default connect(mapStateToProps)(Loader);
